export default __webpack_public_path__ + "static/media/logo.9f4e2a45.svg";